import { useContext, type FC } from 'react';
import type { ScatterPlotProps } from './types';
import ScatterPlotContent from './scatter-plot-content';
import { Widget } from '../../widget';
import { ScatterPlotContext } from '../../../../providers/widgets/scatter-plot-provider/scatter-plot-provider';
import TokenSelector from '../../token-selector';
import Source from '../../source';
import WidgetButtons from '../../widget-buttons';

const ScatterPlotWidget: FC<ScatterPlotProps> = (props) => {
  const { widget, actions } = props;

  const { token, setToken, hasDefaultToken } = useContext(ScatterPlotContext);

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          <TokenSelector token={token} setToken={setToken} isFixedToken={hasDefaultToken} />
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <ScatterPlotContent />
      </Widget.Content>
      <Widget.Footer>
        <div className="footer-content">
          <Source source="Deribit" url="https://deribit.com" />
        </div>
      </Widget.Footer>
    </Widget>
  );
};

export default ScatterPlotWidget;
